/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import draggable from "vuedraggable";

import Vue from 'vue';
import { VueEditor } from "vue2-editor";

export default {
  name: 'tabDetailsEdit',
  components: {
    draggable,
    VueEditor
  },
  data() {
    return {
      submitted: false,
      updateBulletsData: false,
      selectedBulletID: '',
      editBulletPoint: '',
      tabData: {
        courseId: '',
        tabId: '',
        name: '',
        description: '',
        isActive: false,
        tabBulletPoint: '',
        columnIndex: 0
      },
      tabDetails: {},
      isSubmitted: false,
      bulletsPointListFirst: [],
      bulletsPointListSecond: [],
      bulletsPointListThird: [],
      coursesection:null,
      courseDetais:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
    }
  },
  computed: {
    ...mapGetters([
      'getcourseDetailstabByIDState',
      'getsectionbycourseIDState'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    getCourseDetails() {
      this.courseDetais = this.$store.getters.getsectionbycourseIDState.data;
      return this.courseDetais
    },
    getCourseTabDetails() {
      this.$store.dispatch('getCourseTabDetailsByID', {
        id: this.$route.params.tabId
      }).then((response) => {
        if (response.data.code == '2000') {
          this.tabDetails = this.$store.getters.getcourseDetailstabByIDState.data;
          this.tabData.name = this.tabDetails.data.name
          this.tabData.description = this.tabDetails.data.content;
          this.tabData.courseId = this.tabDetails.data.course;
          this.tabData.tabId = this.tabDetails.data.id;
          this.tabData.isActive = this.tabDetails.data.is_active;
          if (this.tabDetails.data.lists && this.tabDetails.data.lists.length > 0) {
            this.bulletsPointListFirst = this.tabDetails.data.lists.filter(item => item.column_index == 0);
            this.bulletsPointListSecond = this.tabDetails.data.lists.filter(item => item.column_index == 1);
            this.bulletsPointListThird = this.tabDetails.data.lists.filter(item => item.column_index == 2);
          }
          return this.tabDetails;
        }
      })
    },
  },
  mounted() {
    this.getCourseTabDetails
  },
  beforeMount() {
    this.getCourseTabDetails;
    this.getCourseDetails;
  },
  watch: {
    getCourseTabDetails() {
      return this.$store.getters.getcourseDetailstabByIDState.data
    },
    getCourseDetails() {
      return this.$store.getters.getsectionbycourseIDState.data
    },
  },
  methods: {
    getCourseTabDetailsAgain() {
      this.$store.dispatch('getCourseTabDetailsByID', {
        id: this.$route.params.tabId
      }).then((res) => {
        this.tabDetails = this.$store.getters.getcourseDetailstabByIDState.data;
        this.tabData.name = this.tabDetails.data.name
        this.tabData.description = this.tabDetails.data.content;
        this.tabData.courseId = this.tabDetails.data.course;
        this.tabData.tabId = this.tabDetails.data.id;
        this.tabData.isActive = this.tabDetails.data.is_active;
        if (this.tabDetails.data.lists) {
          this.bulletsPointListFirst = this.tabDetails.data.lists.filter(item => item.column_index == 0);
          this.bulletsPointListSecond = this.tabDetails.data.lists.filter(item => item.column_index == 1);
          this.bulletsPointListThird = this.tabDetails.data.lists.filter(item => item.column_index == 2);
        }
      }).catch((err) => {})
    },

    courseTabStatusAct(tabId) {
      let data = {
        id: tabId
      }
      this.$store.dispatch('getCourseTabDetailsByID', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.tabData.isActive = this.$store.getters.getcourseDetailstabByIDState.data.data.is_active
            if (this.tabData.isActive === true) {
              this.is_active = false
            }
            if (this.tabData.isActive === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateCourseTabDetailsByID', {
              data: {
                data: data,
                id: tabId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.tabData.isActive = res.data.data.is_active
                toast.success("Course Tab Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },

    validateUpdateCourseTabSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.tabData.name,
            content: this.tabData.description
          }
          this.$store.dispatch('updateCourseTabDetailsByID', {
              data: {
                data: data,
                id: this.tabData.tabId
              }
            }).then((res) => {
              if (res.status == '200') {
                //this.getCourseDetailsAgain();
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {})
          return
        }
      });
    },

    validateCreateBulletBeforeSubmit() {
      this.isSubmitted = true;
      if (this.isSubmitted && this.tabData.tabBulletPoint != '') {
        let data = {
          content: this.tabData.tabBulletPoint,
          course_detail_tab: this.tabData.tabId,
          column_index: this.tabData.columnIndex
        }
        this.$store.dispatch('create_bullets_list', data).then((res) => {
            if (res.status == '201') {
              this.tabData.tabBulletPoint = '';
              this.getCourseTabDetailsAgain();
              toast.success(res.data.msg);
              this.isSubmitted = false;
            }
          })
          .catch((err) => {
            toast.error("Please Create Tab First");
            this.isSubmitted = false;
          })
        return
      }
    },
    PopupClose() {
      this.updateBulletsData = false
    },
    updateBullet(bulletPointId) {
      this.updateBulletsData = true;
      this.selectedBulletID = bulletPointId;
      let data = {
        id: bulletPointId
      }
      this.$store.dispatch('GetBulletdataByID', data)
        .then((res) => {
          this.editBulletPoint = this.$store.getters.getBulletDataByIDState.data.content
        })
        .catch((err) => {})
    },
    updateBulletConfirmation() {
      let data = {
        content: this.editBulletPoint
      }
      this.$store.dispatch('UpdateBulletPointById', {
          data: {
            data: data,
            id: this.selectedBulletID
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseTabDetailsAgain();
          this.updateBulletsData = false
        })
        .catch((err) => {})
    },
    removeBUlletagain(id) {
      $('#removeBulletModalAgain').modal();
      $('body').addClass('removeOverlay');
      this.selectedBulletID = id
    },
    removeBUlletClose() {
      $('body').removeClass('removeOverlay');
    },
    removeBulletConfirmationagain() {
      let data = {
        id: this.selectedBulletID
      }
      this.$store.dispatch('remove_bullets_list', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg);
            this.getCourseTabDetailsAgain();
            $('body').removeClass('removeOverlay');
          }
        })
        .catch((err) => {})
    },
    bulletSort: function(event) {
      if (event.moved && event.moved != undefined) {
        const newColumnIndex = this.getBulletPointIndex(event.moved.element.id);
        this.updateBulletPointIndex(event.moved.element.id, newColumnIndex, Number(event.moved.newIndex) + 1);
      }
      if (event.added && event.added != undefined) {
        const newColumnIndex = this.getBulletPointIndex(event.added.element.id);
        this.updateBulletPointIndex(event.added.element.id, newColumnIndex, Number(event.added.newIndex) + 1);
      }
    },
    getBulletPointIndex(bulletPointId) {
      let columnIndex = 0;
      let listResult1 = this.bulletsPointListFirst.filter(item => item.id == bulletPointId);
      let listResult2 = this.bulletsPointListSecond.filter(item => item.id == bulletPointId);
      let listResult3 = this.bulletsPointListThird.filter(item => item.id == bulletPointId);
      if (listResult1 && listResult1.length > 0) {
        columnIndex = 0;
      }
      if (listResult2 && listResult2.length > 0) {
        columnIndex = 1;
      }
      if (listResult3 && listResult3.length > 0) {
        columnIndex = 2;
      }
      return columnIndex;
    },
    updateBulletPointIndex(bulletPointId, columnIndex, rowIndex) {
      let data = {
        index: rowIndex,
        column_index: columnIndex
      }
      this.$store.dispatch('UpdateBulletPointIndex', {
          data: {
            data: data,
            id: bulletPointId
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseTabDetailsAgain();
          this.updateBulletsData = false
        })
        .catch((err) => {})
    }
  },
  beforeCreate: function() {
    $('body').addClass('tab_details')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('tab_details')
    next();
  }
}